import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class ManikHeaders {
  protected ManikFilterParam1: string = "";
  protected ManikFilterParam2: string = "";
  protected ManikFilterParam3: string = "";
  protected ManikFilterParam4: string = "";
  protected ManikFilterParam5: string = "";
  protected ManikFilterParam6: string = "";
  protected ManikFilterParam7: string = "";
  protected ManikFilterParam8: string = "";
  protected ManikFilterParam9: string = "";
  protected ManikFilterParam10: string = "";
  public EndPoint='';

  constructor() {
    this.EndPoint="https://entityserver.manikworks.com/";
   }

  public prepareLoadHeaders(filterparams: any, context: string = "", lgcontext: string = "") {
    const headers = new HttpHeaders({
      'filterparams': filterparams,
      'context': context,
      'lgcontext': lgcontext
    });
    return headers;
  }

  public prepareLoadHeaders2(filterparams: any, context: string = "", lgcontext: string = "", portalContext: string = "") {
    const headers = new HttpHeaders({
      'EntityActionType':"GET.FORM.DATA",
      'QueryFilter': filterparams,
      'Context': context,
      'LGContext': lgcontext,
      // 'PortalContext': "ECOMM2",
      // 'PortalDS': PortalDS,
      'Authorization': 'Bearer ' + sessionStorage.getItem("sToken")
    });
    return headers;
  }

  public prepareManageHeaders(operation: string, context: string = "", lgcontext: string = "") {
    const headers = new HttpHeaders({
      'operation': operation,
      'context': context,
      'lgcontext': lgcontext
    });
    return headers;
  }

  public prepareManageHeaders2(operation: string, context: string = "", lgcontext: string = "", portalcontext: string = "") {
    const headers = new HttpHeaders({
      'OperationMode': operation,
      'Context': context,
      'LGContext': lgcontext,
      // 'PortalContext': portalcontext,
      'EntityActionType':"ENTITY.MANAGER",
      'Authorization': 'Bearer ' + sessionStorage.getItem("sToken")
    });
    return headers;
  }

  public prepareAddlQueryHeaders(actioncontext: string, context: string = "", lgcontext: string = "") {
    const headers = new HttpHeaders({
      'filterparams': this.stringyfyFilterParams(),
      'actioncontext': actioncontext,
      'context': context,
      'lgcontext': lgcontext
    });
    return headers;
  }

  public prepareAddlQueryHeaders2(actioncontext: string, context: string = "", lgcontext: string = "", portalContext: string = "") {
    const headers = new HttpHeaders({
      'QueryFilter': this.stringyfyFilterParams(),
      'EntityActionType': actioncontext,
      'Context': context,
      'LGContext': lgcontext,
      'PortalContext': portalContext,
      'Authorization': 'Bearer ' + sessionStorage.getItem("sToken")
    });
    return headers;
  }


  public prepareEditHeaders(entityid: any, context: string = "", lgcontext: string = "") {
    const headers = new HttpHeaders({
      'entityid': entityid.toString(),
      'context': context,
      'lgcontext': lgcontext
    });
    return headers;
  }

  public prepareEditHeaders2(entityid: any, context: string = "", lgcontext: string = "", portalcontext: string = "") {
    const headers = new HttpHeaders({
      'EntityActionType':'SINGLE.ENTITY',
      'QueryFilter':entityid? entityid.toString():entityid,
      'Context': context,
      'LGContext': lgcontext,
      'PortalContext': portalcontext,  
      'Authorization': 'Bearer ' + sessionStorage.getItem("sToken")
    });
    return headers;
  }

  public prepareAPIRequestHeaders(apilgcontext: string, apicontext: string, param1: string = "", param2: string = "", param3: string = "") {
    const headers = new HttpHeaders({
      'apilgcontext': apilgcontext,
      'apicontext': apicontext,
      'param1': param1,
      'param2': param2,
      'param3': param3
    });
    return headers;
  }

  public prepareAPIRequestHeaders2(apilgcontext: string, apicontext: string, param1: string = "", param2: string = "", param3: string = "") {
    const headers = new HttpHeaders({
      'Param1':param1,
      'Param2':param2,
      'Param3':param3,
    
      EntityActionType : 'API.REQUEST',
      Context : apicontext,
      LGContext : apilgcontext,
      'Authorization': 'Bearer ' + sessionStorage.getItem("sToken")
    });
    return headers;
  }

  public stringyfyFilterParams(): string {
    let stringyfiedString: string = this.ManikFilterParam1 + "_" + this.ManikFilterParam2 + "_" + this.ManikFilterParam3 + "_" + this.ManikFilterParam4
      + "_" + this.ManikFilterParam5 + "_" + this.ManikFilterParam6 + "_" + this.ManikFilterParam7 + "_" + this.ManikFilterParam8
      + "_" + this.ManikFilterParam9 + "_" + this.ManikFilterParam10;

    while (stringyfiedString[stringyfiedString.length - 1] === "_") {
      stringyfiedString = stringyfiedString.slice(0, -1);
    }

    return stringyfiedString;
  }

  public updateFilterParams(param1: any, param2: any = "", param3: any = "", param4: any = "", param5: any = "", param6: any = "", param7: any = "", param8: any = "", param9: any = "", param10: any = ""): void {
    this.ManikFilterParam1 = param1;
    this.ManikFilterParam2 = param2;
    this.ManikFilterParam3 = param3;
    this.ManikFilterParam4 = param4;
    this.ManikFilterParam5 = param5;
    this.ManikFilterParam6 = param6;
    this.ManikFilterParam7 = param7;
    this.ManikFilterParam8 = param8;
    this.ManikFilterParam9 = param9;
    this.ManikFilterParam10 = param10;
  }
}
